import { Link } from 'react-router-dom'
import { TrendingUp, TrendingDown, Minus } from 'lucide-react'
import { cn } from '../../lib/utils'

interface StatCardProps {
  label: string
  value: number | string
  icon: React.ElementType
  trend?: 'up' | 'down' | 'flat'
  trendValue?: string
  href?: string
}

function TrendIndicator({ trend, trendValue }: { trend: 'up' | 'down' | 'flat'; trendValue?: string }) {
  const Icon = trend === 'up' ? TrendingUp : trend === 'down' ? TrendingDown : Minus
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-xs font-medium',
        trend === 'up' && 'text-green-500',
        trend === 'down' && 'text-red-500',
        trend === 'flat' && 'text-muted-foreground'
      )}
    >
      <Icon className="w-3 h-3" />
      {trendValue && <span>{trendValue}</span>}
    </span>
  )
}

export default function StatCard({ label, value, icon: IconComponent, trend, trendValue, href }: StatCardProps) {
  const content = (
    <div className="rounded-xl border border-border bg-card p-6">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium text-muted-foreground">{label}</span>
        <IconComponent className="w-4 h-4 text-muted-foreground" />
      </div>
      <div className="flex items-end justify-between">
        <span className="text-2xl font-bold">{value}</span>
        {trend && <TrendIndicator trend={trend} trendValue={trendValue} />}
      </div>
    </div>
  )

  if (href) {
    return (
      <Link to={href} className="block hover:opacity-80 transition-opacity">
        {content}
      </Link>
    )
  }

  return content
}
